import { render, staticRenderFns } from "./ManagementContractDetails.vue?vue&type=template&id=7d1185e4&"
import script from "./ManagementContractDetails.vue?vue&type=script&lang=js&"
export * from "./ManagementContractDetails.vue?vue&type=script&lang=js&"
import style0 from "./ManagementContractDetails.vue?vue&type=style&index=0&id=7d1185e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports